import { useCallback, useState } from 'react';

// Returns a PROGRESS indicator (from 0 to 1) during animationBegin+animationDuration milliseconds
const useAnimation = (animationDuration: number = 1000, animationBegin: number = 0) => {
  const [shouldAnimate, setShouldAnimate] = useState<boolean>(true);
  const [progress, setProgress] = useState<number>(0);

  const animationWaitHandler = useCallback(
    (value: number) => {
      // ANIMATION INITIAL WAITING TIME
      const threshold: number = (1 / (animationBegin + animationDuration)) * animationBegin;
      if (value > 1) {
        // ANIMATION ENDED
        setShouldAnimate(false);
      } else if (value > threshold) {
        // ANIMATION RUNNING
        setProgress(value - threshold * (1 - value));
        // console.log('useAnimation', { value, _progress: refProgress.current });
      } else {
        // WAITING TO START
        // console.log('useAnimation - WAITING', { value, threshold });
      }
    },
    [animationBegin, animationDuration]
  );

  return {
    animationWaitHandler,
    shouldAnimate,
    progress,
  };
};

export default useAnimation;
